import React from 'react';
export default function Image(_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, width: "1em", height: "1em", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960" },
        React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M236-277h489L578-473 446-302l-93-127zM120-120v-720h720v720zm60-60h600v-600H180zm0 0v-600z" })));
}
